<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>
                Liefertermin bearbeiten
            </modal-header>
            <modal-content>
                <form-group>
                    <form-input id="delivery_date" name="delivery_date" label="Liefertermin in Bestellung"
                                     v-model="form.delivery_date" :error="form.errors.delivery_date" disabled="true" />

                    <form-datepicker id="delivery_date_corrected" name="delivery_date_corrected" label="Korrigierter Liefertermin"
                                     v-model:date="form.delivery_date_corrected" :error="form.errors.delivery_date_corrected" @update:date="updateEditor" />
                </form-group>

                <form-html id="text" label="Nachricht an Produzenten" v-model="form.text" :error="form.errors.text" height="300px" ref="quill" />
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">Absenden</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import {useForm} from '@inertiajs/vue3';
import FormHtml from '@partfactory/Shared/Form/FormHtml';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import FormInput from '@partfactory/Shared/Form/FormInput';

export default {
    name: 'ProducerLateDeliveryDirectModal',
    components: {
        FormInput,
        FormGroup,
        FormDatepicker,
        FormHtml, ModalContent, ModalHeader, FormButton, ModalActions, Modal},
    props: {
        askForQuote: Object,
    },
    emit: ['closeDialog'],
    data() {
        let text = null;

        const form = useForm({
            delivery_date: this.$date(this.askForQuote?.producer_order?.delivery_date),
            delivery_date_corrected: null,
            text: '<p>Bitte Liefertermin aktualisieren um Nachricht zu laden.</p>',
        });

        return {form, text};
    },
    methods: {
        updateEditor(delivery_date_corrected) {

            if (this.askForQuote?.producer_order?.producer_user?.language === 2) {
                this.$language.current = 'en';
            }

            const translated = this.$gettext('<h1>Guten Tag %{name},</h1>' +
                '<p>wir haben Ihre eingestellte Lieferverzögerung und den Liefertermin auf den <strong>%{delivery_date_corrected}</strong> geändert.</p>');

            this.text = this.$gettextInterpolate(translated, {
                name: this.askForQuote?.producer_order?.producer_user?.name,
                delivery_date_corrected: this.$moment(delivery_date_corrected).format('DD.MM.YYYY'),
            });

            this.$language.current = 'de';

            this.$refs.quill.updateEditor(this.text);
        },
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                    text: this.text,
                }))
                .post(this.$$route('ask-for-quote.delivery.producer-late-delivery-direct', {'askForQuote': this.askForQuote.id}), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        }
    }
};
</script>
